export const jeFieldRearrangementKeys = {
  all: ['jeFieldRearrangement'] as const,
  configs: (companyId: string) => [...jeFieldRearrangementKeys.all, 'configs', companyId] as const,
};
